// src/api/coursePartners.ts

import { BASE_URL } from "../utils/config";
import { CoursePartner, CoursePartnerSummary } from "../types/api";

/**
 * Fetches the active course partners for the /courses index.
 * @throws {Error} If the request fails.
 */
export async function fetchCoursePartners(): Promise<CoursePartnerSummary[]> {
	const response = await fetch(`${BASE_URL}/courses`);
	if (!response.ok) {
		throw new Error(`Failed to fetch course partners: ${response.status}`);
	}
	return (await response.json()) as CoursePartnerSummary[];
}

/**
 * Fetches a public course page. Resolves to null when the course is unknown or inactive.
 * @throws {Error} If the request fails for any other reason.
 */
export async function fetchCoursePartner(slug: string): Promise<CoursePartner | null> {
	const response = await fetch(`${BASE_URL}/courses/${encodeURIComponent(slug)}`);
	if (response.status === 404) return null;
	if (!response.ok) {
		throw new Error(`Failed to fetch course ${slug}: ${response.status}`);
	}
	return (await response.json()) as CoursePartner;
}
